import { API } from "../urls";

// Cookie tabanlı auth: credentials:'include' ile access_token cookie otomatik gönderilir.
const fetchOpts = { credentials: "include" };
const jsonHeaders = { "Content-Type": "application/json" };

/**
 * POS Mutabakat: bir sağlayıcı için cari bazlı çekilen tutar / valörü bu döneme
 * düşen tutar / komisyon hakedişi dökümü.
 * @param {string} provider VirtualPos adı (PAYTR, GARANTI, ...)
 * @param {string} startDate ISO tarih (YYYY-MM-DD)
 * @param {string} endDate   ISO tarih (YYYY-MM-DD)
 * @param {string} [companyId] Yalnız SUPER_ADMIN için etkilidir; kapsamı tek firmaya daraltır.
 */
export const fetchPosReconciliation = async (provider, startDate, endDate, companyId) => {
    const res = await fetch(
        API.get_pos_reconciliation(provider, startDate, endDate, companyId), fetchOpts);
    return res.json();
};

/**
 * İşlem drill-down: işlem bazlı komisyon oranı/tutarı, net yatacak tutar, valör
 * (yatış) tarihi ve oran-artış uyarısı.
 * POS Rapor hiyerarşisinin yaprak ekranıdır: companyId/accountId ile kapsam
 * (POS → firma → cari) daraltılır.
 */
export const fetchPosTransactions = async (provider, startDate, endDate, companyId, accountId, opts = {}) => {
    const res = await fetch(
        API.get_pos_transactions(provider, startDate, endDate, companyId, accountId, opts), fetchOpts);
    return res.json();
};

/** Firmanın POS valör (T+X iş günü) ayarlarını getirir. */
export const fetchPosValorConfig = async (companyId) => {
    const res = await fetch(API.pos_valor_company(companyId), fetchOpts);
    return res.json();
};

/**
 * POS valör ayarlarını kaydeder (upsert).
 * @param {Array<{virtualPos:string, valorDays:number}>} items
 */
export const savePosValorConfig = async (companyId, items) => {
    const res = await fetch(API.pos_valor_company(companyId), {
        ...fetchOpts,
        method: "PUT",
        headers: jsonHeaders,
        body: JSON.stringify(items),
    });
    return res.json();
};

/**
 * Firmanın komisyon hakediş oranlarını getirir. Yanıt tüm POS sağlayıcıları
 * içerir; oranı girilmemiş olanlarda earningPercent null gelir.
 */
export const fetchPosEarningConfig = async (companyId) => {
    const res = await fetch(API.pos_earning_company(companyId), fetchOpts);
    return res.json();
};

/**
 * Hakediş oranlarını kaydeder (upsert). Oranı null gönderilen sağlayıcının kaydı silinir.
 * @param {Array<{virtualPos:string, earningPercent:number|null}>} items
 */
export const savePosEarningConfig = async (companyId, items) => {
    const res = await fetch(API.pos_earning_company(companyId), {
        ...fetchOpts,
        method: "PUT",
        headers: jsonHeaders,
        body: JSON.stringify(items),
    });
    return res.json();
};

/**
 * Anlaşılan (baz) komisyon oranlarını kaydeder.
 * @param {Array<{virtualPos:string, cardBrand:string, installmentCount:number, baselineCommissionPercent:number|null}>} items
 */
export const savePosBaselines = async (companyId, items) => {
    const res = await fetch(API.active_pos_baselines(companyId), {
        ...fetchOpts,
        method: "PUT",
        headers: jsonHeaders,
        body: JSON.stringify(items),
    });
    return res.json();
};
